import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const items = [
  "Generative AI",
  "Digital Transformation",
  "Cloud Solutions",
  "Data & Intelligence",
  "eSignature",
  "Process Automation",
  "Staffing ERP",
  "Business Applications",
];

const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="py-8 border-y border-slate-100 bg-slate-50/60 overflow-hidden">
    <Marquee speed={45} gradient={false} pauseOnHover>
      {items.map((item) => (
        <span key={item} className="flex items-center gap-8 pr-8">
          <span className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-slate-300 hover:text-miti-blue transition-colors duration-300">
            {item}
          </span>
          <Sparkle size={18} className="text-miti-blue/50" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
